import { DealForecastStateMode } from '@openx/types/dealForecasting.ts';
import type { DealForecastState as DealForecastStateType } from '@openx/types/store/deal.ts';

import { DealForecastState } from '../components/DealForecastState.tsx';

export const renderStateComponent = ({ disabled, loading, job_id, error }: DealForecastStateType) => {
  const noData = disabled && !job_id && !loading;
  const allSet = !error && !disabled && !job_id;

  if (loading) {
    return <DealForecastState mode={DealForecastStateMode.Loading} />;
  }

  if (noData) {
    return <DealForecastState mode={DealForecastStateMode.No_Data} />;
  }

  if (allSet) {
    return <DealForecastState mode={DealForecastStateMode.All_Set} />;
  }

  if (error) {
    return <DealForecastState mode={DealForecastStateMode.Error} error={error} />;
  }
};
